import React from 'react';
import { Color } from 'modules/styles/colors';
import { renderIcon, renderWithBorder } from 'components/InfoButton';

interface Props {
  handleRequestOpen: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  hideBorder?: boolean;
  color?: string;
}

export function InfoButton({ handleRequestOpen, hideBorder, color = Color.offBlack }: Props) {
  const renderIconProps = { handleRequestOpen, color, title: 'Term Definitions' };
  return hideBorder ? renderIcon(renderIconProps) : renderWithBorder(renderIconProps);
}
